"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _nprogress = _interopRequireDefault(require("nprogress"));

require("./styles/apolloNetworkStatus.less");

var _initApollo = require("./utils/initApollo");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
// definition
var _default = /*#__PURE__*/_react["default"].memo(function () {
  var apolloNetworkStatus = (0, _initApollo.useApolloNetworkStatus)();
  var numPendingQueries = apolloNetworkStatus.numPendingQueries;
  var maxRef = (0, _react.useRef)(0);
  var prevNumPendingQueries = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    if (numPendingQueries > 0) {
      if (prevNumPendingQueries.current < numPendingQueries) maxRef.current += 1;

      _nprogress["default"].configure({
        showSpinner: false
      });

      _nprogress["default"].set((maxRef.current - numPendingQueries) / maxRef.current);
    } else {
      maxRef.current = 0;

      _nprogress["default"].done();
    }

    prevNumPendingQueries.current = numPendingQueries;
  }, [numPendingQueries]);
  return null;
});

exports["default"] = _default;